// Copyright ©️ 2026 eVolve MEP, LLC

import type { StrongOmit } from '@evolvemep/api-ts';
import { Anchor } from '@mantine/core';
import type { LinkProps } from 'react-router';

import { moduleRoute } from 'app/Layout/NavBar/globalNavigationMenu';
import type { ShopNavigationRoute } from 'app/ModuleRoutes';

import type { PageTitle } from './types';
import { useEvolveNavigate } from './useEvolveNavigate';

type Props = (
  | {
      from: PageTitle | string;
      clearHistory?: boolean;
    }
  | {
      from?: PageTitle;
      clearHistory: true;
    }
) & {
  to: ShopNavigationRoute;
} & StrongOmit<
    LinkProps,
    | 'to'
    // state is managed internally by useEvolveNavigate
    | 'state'
  >;

export const EvolveLink = ({ to, children, onClick, ...props }: Props) => {
  const navigate = useEvolveNavigate(props.from ?? '');

  return (
    <Anchor
      href={`/${moduleRoute}${to}`}
      onClick={(e) => {
        if (!e.ctrlKey) {
          onClick?.(e);
          void navigate(to);
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      {...props}
      className={`link ${props.className}`}
    >
      {children}
    </Anchor>
  );
};
